import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export const useNotificationPreferences = (userId) => {
  const [preferences, setPreferences] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (userId) {
      fetchPreferences();
    }
  }, [userId]);

  const fetchPreferences = async () => {
    try {
      setLoading(true);
      
      const { data, error } = await supabase
        .from('notification_preferences')
        .select('*')
        .eq('user_id', userId)
        .single();

      if (error) {
        // If no preferences exist, create default ones
        if (error.code === 'PGRST116') {
          await createDefaultPreferences();
          return;
        }
        throw error;
      }

      setPreferences(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching notification preferences:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const createDefaultPreferences = async () => {
    try {
      const { data, error } = await supabase
        .from('notification_preferences')
        .insert([{
          user_id: userId,
          email_notifications: true,
          push_notifications: true,
          notify_session_reminder: true,
          notify_streak_milestone: true,
          notify_new_content: true,
          notify_progress_updates: true,
          notify_session_completion: true,
          notify_premium_features: true
        }])
        .select()
        .single();

      if (error) throw error;
      
      setPreferences(data);
      setError(null);
    } catch (err) {
      console.error('Error creating default preferences:', err);
      setError(err.message);
    }
  };

  const updatePreferences = async (updates) => {
    try {
      const { data, error } = await supabase
        .from('notification_preferences')
        .update(updates)
        .eq('user_id', userId)
        .select()
        .single();

      if (error) throw error;

      setPreferences(data);
      setError(null);
      return { success: true };
    } catch (err) {
      console.error('Error updating notification preferences:', err);
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  return {
    preferences,
    loading,
    error,
    updatePreferences,
    refreshPreferences: fetchPreferences
  };
};